import {i18n} from '@yourcoach/i18n';

export interface IScheduleItemRepeat {
  id: string;
  interval: number;
  toString: () => string;
}

export const ScheduleItemRepeat: {[key: string]: IScheduleItemRepeat} = {
  BI_WEEKLY: {
    id: 'bi_weekly',
    interval: 14,
  },
  DAILY: {
    id: 'daily',
    interval: 1,
  },
  MONTHLY: {
    id: 'monthly',
    interval: 30,
  },
  ONE_TIME: {
    id: 'one_time',
    interval: 0,
  },
  WEEKLY: {
    id: 'weekly',
    interval: 7,
  },
};

Object.keys(ScheduleItemRepeat).forEach(key => {
  const repeat = ScheduleItemRepeat[key]!;

  repeat.toString = () =>
    /**
     * @i18n_parser
     * t('shared:schedule_item.repeat.bi_weekly')
     * t('shared:schedule_item.repeat.daily')
     * t('shared:schedule_item.repeat.monthly')
     * t('shared:schedule_item.repeat.one_time')
     * t('shared:schedule_item.repeat.weekly')
     */
    i18n.t(`shared:schedule_item.repeat.${repeat.id}`);
});
